import {ActivatedOrInactivated, ButtonText, Deleted, EditOrCreate, Tip} from "_utils/txt";
import {_} from "_utils/url";

const entity = 'atendimento';
const entities = `${entity}s`;
const prep = 'a';
const entityRoute = 'queue';

export const E = {
    name: entity,
    capName: entity.charAt(0).toUpperCase() + entity.slice(1),
    plural: entities,
    capPlural: entities.charAt(0).toUpperCase() + entities.slice(1),
    prep: prep,

    add: ButtonText(entity).add,

    toast: {
        editedOrCreated: (isEditing: boolean) => EditOrCreate(isEditing, entity, prep).toast,
        activeOrInactive: (isActive: boolean) => ActivatedOrInactivated(isActive, E.capName, prep).toast,
        deleted: () => Deleted(E.capName, prep).toast,
    },

    title: {
        editingOrCreating: (isEditing: boolean) => EditOrCreate(isEditing, entity, prep).title
    },

    tip: {
        view: Tip(entity).view,
        viewClient: 'Visualizar solicitante',
        edit: Tip(entity).edit,
        toggleActive: Tip(entity).toggleActive,
        delete: Tip(entity).delete,
    },

    url: {
        list: _('/admin', 'service', 'queue'),
        edit: (id: string) => _('/admin', 'params', entityRoute, id, 'edit'),
        view: (id: string) => _('/admin', 'params', entityRoute, id, 'view'),
    }
}
